/**
 * GraphQL type definitions matching backend schema — stakeholder pillar.
 * Split from graphql/types.ts (issue #1409).
 */

import type { PageInfo } from './common';

/**
 * Stakeholder type enumeration
 */
export enum StakeholderType {
  PartnerAgencyOwner = 'PartnerAgencyOwner',
  PartnerOwner = 'PartnerOwner',
}

/**
 * Stakeholder entity
 */
export interface Stakeholder {
  entityId: string;
  entityType: string;
  name: string;
  description?: string | null;
  stakeholderType: StakeholderType;
  contactEmail?: string | null;
  organization?: string | null;
  _schemaVersion: string;
  _createdAt: string;
  _createdBy: string;
  _updatedAt: string;
  _updatedBy: string;
  _deletedAt?: string | null;
}

/**
 * Stakeholder edge for pagination
 */
export interface StakeholderEdge {
  node: Stakeholder;
  cursor: string;
}

/**
 * Stakeholder connection for paginated results
 */
export interface StakeholderConnection {
  edges: StakeholderEdge[];
  pageInfo: PageInfo;
  totalCount?: number | null;
}

/**
 * Input for filtering stakeholders
 */
export interface StakeholderFilter {
  stakeholderType?: StakeholderType;
  includeDeleted?: boolean;
}
